module.exports = __webpack_public_path__ + "media/images/custom_link-2d5740fbdd6f145866afa316cf424e96.png";